import { render, staticRenderFns } from "./tipqiandaoLayer.vue?vue&type=template&id=68cccd6e&scoped=true&"
import script from "./tipqiandaoLayer.vue?vue&type=script&lang=js&"
export * from "./tipqiandaoLayer.vue?vue&type=script&lang=js&"
import style0 from "./tipqiandaoLayer.vue?vue&type=style&index=0&id=68cccd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cccd6e",
  null
  
)

export default component.exports